<div class="content-header bg-primary" [class.bg-image]="hasBgImage" [ngClass]="class">
  
  <app-breadcrumb [hidden]="hideBreadcrumb"></app-breadcrumb>
  <mat-icon *ngIf="icon" class="mat-icon-xlg">{{icon}}</mat-icon>
  <h3 *ngIf="title" class="loginHeadingText">{{title}}</h3>
  <h4 *ngIf="desc" class="p-2">{{desc}}</h4>
</div>